import { service_translate_generations } from '@/services/translate/SERVICE__translate_generations';
import { LOCAL__user_task_upsert } from '@/state/generation/user_task/entity/LOCAL__user_task_upsert';
import { store } from '@/state/store';
import { FN_WORDS__init_in_tokens_generation } from '@/state/words/_methods/FN_WORDS__init_in_tokens_generation';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { FN_GRID2D__init_possible_features } from '../../_methods/FN_GRID2D__init_possible_features';
import { FN_IMAGE_ASSET__add_to_generation_single } from '../image/_methods/FN_IMAGE_ASSET__add_to_generation_single';

export function HANDLER_CLIENT__user_task_upsert(items: any) {
  assert_array_instanceof(items, DTO__user_task);

  let generations = items.flatMap(user_task => user_task.generations);
  let images_map = store.getState().slice_images.images_map;

  generations.map(generation => FN_IMAGE_ASSET__add_to_generation_single(generation, images_map));

  FN_GRID2D__init_possible_features(items);
  FN_GRID2D__init_possible_features(generations);

  FN_WORDS__init_in_tokens_generation(generations);

  service_translate_generations.on_generations_received(generations);

  store.dispatch(LOCAL__user_task_upsert(items));
}
